import angular from 'angular';
import { FocusOn } from './focus-on.directive';
import { FocusOnService } from './focus-on.service';
export var FocusOnDirectiveModule = angular
    .module('FocusOnDirectiveModule', [])
    .service('FocusOnService', FocusOnService)
    .directive('focusOn', FocusOn)
    .name;
//# sourceMappingURL=focus-on.module.js.map